import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  settingsMenuContent: {
    alignItems: 'flex-start',
    height: Theme.px(1080),
    paddingBottom: Theme.px(130),
    paddingLeft: Theme.px(90),
    paddingTop: Theme.px(290),
    width: Theme.px(405),
  },
});
